import { IntegrationChannelType } from 'generated/graphql';

interface GetCanReauthorizeIntegrationParams {
  channelType: IntegrationChannelType;
}

export const getCanReauthorizeIntegration = ({
  channelType,
}: GetCanReauthorizeIntegrationParams) => {
  switch (channelType) {
    case IntegrationChannelType.FileUpload:
    case IntegrationChannelType.Discourse:
    case IntegrationChannelType.Twitter:
    case IntegrationChannelType.Email:
    case IntegrationChannelType.Webhook:
    case IntegrationChannelType.G2:
      return false;
    default:
      return true;
  }
};
